
import { defineComponent } from 'vue';
import HeaderLogo from '@/components/Layout/HeaderLogo.vue';
import { clearStorage } from '@/storage';

export default defineComponent({
  name: 'PortalHeader',

  components: { HeaderLogo },

  computed: {
    menuItems() {
      return [{ icon: 'mdi-logout', label: 'Log Out', action: this.logout }];
    }
  },

  methods: {
    logout() {
      clearStorage();
      window.location.reload();
    }
  }
});
